import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-skip-to-content',
	templateUrl:'./WaPageSkipToContentProPage.html',
	styles: [],
	styleUrls:['./WaPageSkipToContentProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageSkipToContentProPage
{
	mdContent_413 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageSkipToContent;
\`\`\``;
	mdContent_414 = `\`\`\`java
new WaPageSkipToContent<>()
\`\`\``;
}
